<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section class="section-medium">
    <!-- TOP ANCHOR FOR SCROLL ON ERROR -->
    <div #formTop></div>

    <ion-text color="primary">
      <h2 class="form-title ion-text-center">My Profile</h2>
    </ion-text>

    <form [formGroup]="profileForm" (ngSubmit)="onSubmit(profileForm.value)">
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <div *ngIf="errorResponse" class="alert-bar">
              {{ errorResponse }}
            </div>
            <div *ngIf="successResponse" class="alert-bar color-success">
              {{ successResponse }}
            </div>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-label>First name*</ion-label>
            <ion-input
              type="text"
              required
              autocomplete="off"
              name="firstName"
              formControlName="firstName"
            ></ion-input>
            <small
              *ngIf="profileForm.controls['firstName'].invalid && (profileForm.controls['firstName'].touched || submitted) && profileForm.controls['firstName'].errors.required"
              class="form-error"
            >
              <ion-note color="danger"> Please enter your First name </ion-note>
            </small>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-label>Last name*</ion-label>
            <ion-input
              type="text"
              required
              autocomplete="off"
              name="lastName"
              formControlName="lastName"
            ></ion-input>
            <small
              *ngIf="profileForm.controls['lastName'].invalid && (profileForm.controls['lastName'].touched || submitted) && profileForm.controls['lastName'].errors.required"
              class="form-error"
            >
              <ion-note color="danger"> Please enter your Last name </ion-note>
            </small>
          </ion-col>

          <ion-col size="12" size-md="6">
            <ion-label>Email*</ion-label>
            <ion-input
              type="email"
              required
              autocomplete="off"
              name="emailAdd"
              formControlName="emailAdd"
              readOnly
            ></ion-input>
            <small
              *ngIf="profileForm.controls['emailAdd'].invalid && (profileForm.controls['emailAdd'].touched || submitted) && profileForm.controls['emailAdd'].errors.required"
              class="form-error"
            >
              <ion-note color="danger"> Please enter your Email </ion-note>
            </small>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-label>Phone number*</ion-label>
            <ion-input
              type="tel"
              required
              autocomplete="mobile"
              name="mobile"
              formControlName="mobile"
            ></ion-input>
            <small
              *ngIf="profileForm.controls['mobile'].invalid && (profileForm.controls['mobile'].touched || submitted) && (profileForm.controls['mobile'].errors.required || profileForm.controls['mobile'].errors.pattern || profileForm.controls['mobile'].errors.mobileMinLengthError)"
              class="form-error"
            >
              <ion-note color="danger"
                >Please ensure your phone number is at least 10 characters
                long</ion-note
              >
            </small>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-label>Date of birth*</ion-label>
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <ng-select
                    class="mb-0"
                    autocomplete="off"
                    name="dobDay"
                    formControlName="dobDay"
                    required
                  >
                    <ng-option value="">dd</ng-option>
                    <ng-option *ngFor="let day of dobDayValues" [value]="day">
                      {{day}}
                    </ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size="4">
                  <ng-select
                    class="mb-0"
                    autocomplete="off"
                    name="dobMonth"
                    formControlName="dobMonth"
                    required
                  >
                    <ng-option value="">mm</ng-option>
                    <ng-option
                      *ngFor="let month of dobMonthValues"
                      [value]="month"
                    >
                      {{month}}
                    </ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size="4">
                  <ng-select
                    class="mb-0"
                    autocomplete="off"
                    name="dobYear"
                    formControlName="dobYear"
                    required
                  >
                    <ng-option value="">yyyy</ng-option>
                    <ng-option
                      *ngFor="let year of dobYearValues"
                      [value]="year"
                    >
                      {{year}}
                    </ng-option>
                  </ng-select>
                </ion-col>
              </ion-row>
              <ion-row class="mb-20" *ngIf="!ageValid && submitted">
                <ion-col size="12">
                  <ion-item>
                    <small class="form-error">
                      <ion-note color="danger">
                        Subscriber must be 18 years or older</ion-note
                      >
                    </small>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-label>Gender</ion-label>
            <ng-select
              autocomplete="off"
              name="gender"
              formControlName="gender"
            >
              <ng-option value="">select</ng-option>
              <ng-option value="female">Female</ng-option>
              <ng-option value="male">Male</ng-option>
              <ng-option value="other">Other</ng-option>
            </ng-select>
          </ion-col>

          <ion-col size="12" size-md="6">
            <ion-item>
              <ion-label>I accept to receive communications from:</ion-label>
            </ion-item>
            <ion-list>
              <ion-item *ngFor="let optin of optinsList; let i = index">
                <ion-checkbox
                  slot="start"
                  color="secondary"
                  [value]="optin.optIn"
                  [checked]="optin.optIn"
                  (ionChange)="toggleOptin(optin)"
                ></ion-checkbox>
                <ion-label> {{ optin.name }} </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>

          <ion-col size="12">
            <app-button type="secondary" [submitType]="true"
              [icon]="loading ? undefined : { name: 'arrow-right', position: 'right' }">
              <ion-spinner *ngIf="loading" slot="end" name="crescent"></ion-spinner>
              Update
            </app-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
